/* Mission Beard — Beard Oil PDP interactivity.
   Reads config + initial state from data attributes on the .bo-pdp root.
   Handles: gallery, scent picker (Step 01 = navigate; mix-match = local), qty tiers,
   mix & match slots, FAQ accordion, sticky bar, carousels, ATC. */
(function () {
  function init(root) {
    if (!root || root.dataset.boInit === '1') return;
    root.dataset.boInit = '1';

    /* FAQ accordion — runs on any .bo-pdp wrapper, no config required.
       Attached before the config check so it works on the standalone FAQ section too. */
    root.querySelectorAll('.faq-item').forEach(function (item) {
      var btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('open');
        root.querySelectorAll('.faq-item.open').forEach(function (o) { o.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });

    var configEl = root.querySelector('[data-bo-config]');
    var config = configEl ? JSON.parse(configEl.textContent) : null;
    if (!config) return;

    var state = {
      primary: config.current.scentId,
      qty: config.defaultQty || 4,
      slots: [],
      gallery: 0
    };

    // Initial slots
    var initialSlots = (config.initialSlots && config.initialSlots.length) ? config.initialSlots.slice() : [];
    while (initialSlots.length < state.qty) initialSlots.push(state.primary);
    initialSlots.length = state.qty;
    state.slots = initialSlots;

    var scents = config.scents;
    var tiers = config.tiers;
    var currency = config.currencySymbol || '£';

    /* ────── Helpers ────── */
    function money(n) {
      return currency + Number(n).toFixed(2);
    }
    function scent(id) { return scents[id]; }
    function tier(q)   { return tiers[q - 1]; }

    /* ────── GALLERY ────── */
    var galleryMain   = root.querySelector('.gallery-main');
    var galleryThumbs = root.querySelectorAll('.gallery-thumb');
    var galleryItems  = (config.gallery || []);

    function renderGallery() {
      var it = galleryItems[state.gallery];
      if (!it || !galleryMain) return;
      var badge = galleryMain.querySelector('.gallery-badge');
      galleryMain.innerHTML = '';
      if (badge) galleryMain.appendChild(badge);
      if (it.type === 'video') {
        var poster = document.createElement('img');
        poster.className = 'video-poster';
        poster.src = it.poster;
        poster.alt = it.alt || '';
        galleryMain.appendChild(poster);
        var play = document.createElement('button');
        play.className = 'play-button';
        play.setAttribute('aria-label', 'Play video');
        play.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"><polygon points="6 4 22 12 6 20 6 4"/></svg>';
        galleryMain.appendChild(play);
      } else {
        var img = document.createElement('img');
        img.src = it.src;
        img.alt = it.alt || '';
        galleryMain.appendChild(img);
      }
      galleryThumbs.forEach(function (t, i) {
        t.classList.toggle('active', i === state.gallery);
      });
    }
    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        state.gallery = parseInt(thumb.dataset.index, 10) || 0;
        renderGallery();
      });
    });

    /* ────── SCENT CARDS (Step 01) ────── */
    // Cards for non-current scents are <a> elements that navigate away.
    // The current scent card is .active and inert.
    // (Markup wires this — no JS click handler needed for navigation.)

    /* ────── TIER TILES (Step 02) ────── */
    var tierEls = root.querySelectorAll('.tier');
    function renderTiers() {
      tierEls.forEach(function (el) {
        var q = parseInt(el.dataset.qty, 10);
        el.classList.toggle('active', q === state.qty);
      });
    }
    tierEls.forEach(function (el) {
      el.addEventListener('click', function () {
        state.qty = parseInt(el.dataset.qty, 10) || 1;
        // Resize slots
        while (state.slots.length < state.qty) state.slots.push(state.primary);
        state.slots.length = state.qty;
        renderAll();
      });
    });

    /* ────── MIX & MATCH ────── */
    var mixWrap = root.querySelector('.mix');
    function renderMix() {
      if (!mixWrap) return;
      mixWrap.style.display = state.qty > 1 ? '' : 'none';
      var rows = mixWrap.querySelectorAll('.mix-row');
      rows.forEach(function (row, i) {
        row.style.display = i < state.qty ? '' : 'none';
        var slotId = state.slots[i];
        row.querySelectorAll('.sw').forEach(function (sw) {
          sw.classList.toggle('active', sw.dataset.scentId === slotId);
        });
      });
      var label = mixWrap.querySelector('.mix-label');
      if (label) label.textContent = 'Mix & match your ' + state.qty + ' scent' + (state.qty === 1 ? '' : 's');
      var allBtn = mixWrap.querySelector('.quick-all');
      if (allBtn) allBtn.textContent = 'All ' + scent(state.primary).name;
      var oneOfEachBtn = mixWrap.querySelector('.quick-each');
      if (oneOfEachBtn) oneOfEachBtn.style.display = state.qty === 4 ? '' : 'none';
    }
    function isAvailable(id) {
      var s = scents[id];
      return !s || s.available !== false;
    }
    if (mixWrap) {
      mixWrap.addEventListener('click', function (e) {
        var sw = e.target.closest('.sw');
        if (sw) {
          if (sw.getAttribute('data-sold-out') === 'true') return;
          var row = sw.closest('.mix-row');
          var i = parseInt(row.dataset.slot, 10);
          var id = sw.dataset.scentId;
          state.slots[i] = id;
          if (i === 0) state.primary = id;
          renderAll();
          return;
        }
        if (e.target.closest('.quick-all')) {
          if (!isAvailable(state.primary)) return;
          for (var j = 0; j < state.qty; j++) state.slots[j] = state.primary;
          renderAll();
        } else if (e.target.closest('.quick-each')) {
          var ids = Object.keys(scents).filter(isAvailable);
          if (!ids.length) return;
          var slots = [];
          for (var k = 0; k < state.qty; k++) slots.push(ids[k % ids.length]);
          state.slots = slots;
          state.primary = state.slots[0];
          renderAll();
        }
      });
    }

    /* ────── ATC + STICKY BAR PRICING ────── */
    var atcBtn  = root.querySelector('.atc-btn');
    var stickyBar = document.querySelector('.bo-pdp-stickybar');

    function renderPricing() {
      var t = tier(state.qty);
      if (atcBtn) {
        var total = atcBtn.querySelector('.total .now');
        var strike = atcBtn.querySelector('.total .strike');
        if (total) total.textContent = money(t.total);
        if (strike) {
          if (t.save > 0) {
            strike.style.display = '';
            strike.textContent = money(t.q * tiers[0].per);
          } else {
            strike.style.display = 'none';
          }
        }
      }
      if (stickyBar) {
        var sbT = stickyBar.querySelector('.t');
        var sbP = stickyBar.querySelector('.p .now');
        var sbS = stickyBar.querySelector('.p .strike');
        if (sbT) sbT.textContent = scent(state.primary).name + ' · ' + state.qty + ' × 30ml';
        if (sbP) sbP.textContent = money(t.total);
        if (sbS) {
          if (t.save > 0) {
            sbS.style.display = '';
            sbS.textContent = money(t.q * tiers[0].per);
          } else {
            sbS.style.display = 'none';
          }
        }
      }
    }

    /* ────── Subtitle pip color reflects current scent (not changed by mix-match — current scent is fixed by URL) ────── */
    // (intentionally not re-rendered)

    function renderAll() {
      renderTiers();
      renderMix();
      renderPricing();
      root.classList.toggle('qty-multi', state.qty > 1);
    }

    /* ────── ATC behaviour ────── */
    function buildLineItems() {
      var counts = {};
      state.slots.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = [];
      for (var id in counts) {
        var s = scent(id);
        if (!s || !s.variantId) {
          throw new Error("The " + (s ? s.name : id) + " scent isn't live yet — pick a different scent in your mix.");
        }
        items.push({ id: Number(s.variantId), quantity: counts[id] });
      }
      return items;
    }


    function notifyCartChanged() {
      // Fire the common cart-drawer events so Opus Cart (and most other drawer apps)
      // pick up the change and open. Each app listens to a slightly different name;
      // dispatching several covers most.
      var names = ['cart:refresh', 'cart:updated', 'cart:add', 'cart:change', 'shopify:cart:add'];
      names.forEach(function (n) {
        document.documentElement.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'bo-pdp' } }));
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { source: 'bo-pdp' } }));
      });
    }

    function reportError(msg, details) {
      console.error('[bo-pdp] ' + msg, details || '');
      // alert() is blocked in the theme editor iframe sandbox, so try it but don't rely on it.
      try { alert(msg); } catch (_) {}
    }

    function handleAtc() {
      console.log('[bo-pdp] ATC clicked. state =', JSON.parse(JSON.stringify(state)));
      var items;
      try { items = buildLineItems(); }
      catch (err) { reportError(err.message, err); return; }
      console.log('[bo-pdp] line items to add =', items);
      atcBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          console.log('[bo-pdp] /cart/add.js response status =', r.status);
          if (!r.ok) {
            return r.text().then(function (txt) {
              console.error('[bo-pdp] /cart/add.js error body =', txt);
              var parsed;
              try { parsed = JSON.parse(txt); } catch (_) {}
              throw new Error((parsed && parsed.description) || ('Could not add to cart (' + r.status + ')'));
            });
          }
          return r.json();
        })
        .then(function (cart) {
          console.log('[bo-pdp] cart after add =', cart);
          notifyCartChanged();
          atcBtn.disabled = false;
        })
        .catch(function (err) {
          atcBtn.disabled = false;
          reportError(err.message || 'Could not add to cart', err);
        });
    }
    if (atcBtn) atcBtn.addEventListener('click', handleAtc);
    if (stickyBar) {
      var sbBtn = stickyBar.querySelector('.btn');
      if (sbBtn) sbBtn.addEventListener('click', handleAtc);
    }

    /* ────── STICKY BAR show/hide ────── */
    if (stickyBar) {
      window.addEventListener('scroll', function () {
        stickyBar.classList.toggle('show', window.scrollY > 800);
      }, { passive: true });
    }

    /* ────── CAROUSELS ────── */
    function wireCarousel(rootEl, trackSel, cardSel, prevSel, nextSel, dotSel, gap) {
      var track = rootEl.querySelector(trackSel);
      if (!track) return;
      var step = function () {
        var card = track.querySelector(cardSel);
        return card ? card.offsetWidth + (gap || 24) : 360;
      };
      var prev = rootEl.querySelector(prevSel);
      var next = rootEl.querySelector(nextSel);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(),  behavior: 'smooth' }); });
      var dots = dotSel ? rootEl.querySelectorAll(dotSel) : [];
      if (dots.length) {
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function () {
            var card = track.children[i];
            if (card) track.scrollTo({ left: card.offsetLeft - 24, behavior: 'smooth' });
          });
        });
        track.addEventListener('scroll', function () {
          var s = step();
          var i = Math.max(0, Math.min(dots.length - 1, Math.round(track.scrollLeft / s)));
          dots.forEach(function (d, j) { d.classList.toggle('active', j === i); });
        }, { passive: true });
      }
    }

    var vcSection = document.querySelector('.bo-pdp .vcsection');
    if (vcSection) wireCarousel(vcSection, '.vcarousel', '.vcard', '.vc-prev', '.vc-next', '.vc-dot', 16);

    var ts = document.querySelector('.bo-pdp .testimonials');
    if (ts) wireCarousel(ts, '.testimonials-track', '.tcard', '.t-prev', '.t-next', null, 24);

    /* ────── Initial paint ────── */
    renderAll();
    if (galleryMain) renderGallery();
  }

  function boot() {
    document.querySelectorAll('.bo-pdp[data-bo-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
